module.exports = __webpack_public_path__ + "brandon_thin-webfont.b68d5f37232e1999430b.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/brandon_thin-webfont.woff
// module id = 951
// module chunks = 7